import React from 'react';
import {
  Box,
  Dialog,
  Grid,
  Typography,
  DialogTitle,
  IconButton,
  CloseIcon,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Oval } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

import { Button } from '@components';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './PaymentConfirmationModal.json';
import { amountToCurrencyString } from '@utils/currency';
import exit from '@assets/exitIcon.svg';

const _ = require('lodash');

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'SchnyderSLight',
  },
  closeImg: {
    cursor: 'pointer',
    float: 'right',
    marginTop: '5px',
    width: '20px',
  },
  paymentContainer: {
    padding: '0px 40px 0px 40px',
  },
}));

export const PaymentConfirmationModal = ({ open, onClose, paymentDetails }) => {
  const classes = useStyles();
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  const amountChargedString = amountToCurrencyString(
    paymentDetails?.amount,
    paymentDetails?.currency,
    language
  ).toString();
  const { date, last4, type, accountType, brand, bankName } = {
    date: new Date(Date(paymentDetails?.created)).toLocaleDateString(language, {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    }),
    type: _.startCase(paymentDetails?.payment_method_type || 'card'),
    accountType: _.startCase(paymentDetails?.accountType || 'credit'),
    brand: _.startCase(paymentDetails?.brand || 'visa'),
    bankName: _.startCase(paymentDetails?.bankName || ''),
    last4: paymentDetails?.last4 || '1234',
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        style={{ position: 'absolute', right: 10, top: 10, padding: 0 }}
      >
        <a className={classes.closeImg} onClick={onClose}>
          <img src={exit} alt="exit" />
        </a>
      </DialogTitle>
      <Box paddingY={6} paddingX={2}>
        <Grid container spacing={4} className={classes.paymentContainer}>
          <Grid item xs={12} container>
            <Typography variant="h4" className={classes.title}>
              {l(content.confirmed, language)}
            </Typography>
          </Grid>
          <Grid item xs={12} container>
            <Typography variant="body1" data-payment-processing-amount-charged>
              {paymentDetails?.payment_method_type === 'card'
                ? l(content.thankyou2, language)
                : l(content.thankyou, language)}
            </Typography>
          </Grid>
          {paymentDetails?.payment_method_type !== 'card' && (
            <Grid item xs={12} container justifyContent="center">
              <Typography
                variant="body1"
                data-payment-processing-amount-charged
              >
                {l(content.info, language)}
              </Typography>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            container
            style={{
              display: 'flex',
              margin: 0,
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" data-payment>
              Payment
              <div style={{ fontSize: '14px' }}>
                {date +
                  (paymentDetails?.payment_method_type === 'account'
                    ? `\t${bankName}`
                    : '') +
                  `\t${accountType} ${type}` +
                  (paymentDetails?.payment_method_type === 'card'
                    ? `\t${brand}`
                    : '') +
                  `\t****${last4}`}
              </div>
            </Typography>
            <Typography variant="body1" data-payment-processing-amount-charged>
              {amountChargedString}
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Button onClick={onClose} text="Done" hoverColor="#555354" />
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
